import useData from 'store/useData';

export const getPabyName = (name: string) => {
  const avatars = useData.getState().avatars;
  if (name === 'PA') {
    return 'PA';
  }
  const avatar: any = avatars?.find(
    (avatar: any) => avatar?.name?.trim() === name?.trim(),
  );
  return (avatar && avatar?.media[0]?.location) || '';
};
